import React, { FC } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Paper } from "@mui/material";
import { useQuery } from "react-query";
import { BeatLoader } from "react-spinners";

interface Props {
  id: string;
  cN?: string;
  value: any;
  setValue: (value: any) => void;
}

interface Option {
  id: string;
  name: string;
}

// Fetch jobPosts. (based on search params)
const fetchRemoteRegions = async () => {
  const url = `/api/job-posts/remote-regions`;
  return fetch(url).then((res) => res.json());
};

export const AsyncAutocompleteRemoteRegions: FC<Props> = ({
  id,
  cN,
  value,
  setValue,
}) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState<readonly Option[]>([]);

  const { isLoading } = useQuery(["remoteRegions"], fetchRemoteRegions, {
    onSuccess: (data) => {
      const sortedOptions = data.sort((a, b) =>
        a.name < b.name ? -1 : a.name > b.name ? 1 : 0
      );
      setOptions(sortedOptions);
    },
  });

  return isLoading ? (
    <BeatLoader size={8} margin={2} color="#aaa" />
  ) : (
    <Autocomplete
      multiple
      id={id}
      classes={{
        inputFocused: "focus:ring-0",
      }}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      value={value}
      onChange={(_, value) => {
        const ids = value.map((option) =>
          typeof option === "string" ? option : option.id
        );
        setValue(ids);
      }}
      options={options.map((option) => option.id)}
      groupBy={(option) => option.country}
      getOptionLabel={(option) => options.find((o) => o.id === option)?.name}
      isOptionEqualToValue={(option, value) => {
        return option === value;
      }}
      loading={isLoading}
      filterSelectedOptions
      PaperComponent={({ children }) => (
        <Paper
          // This is to work together with SearchFields UI, specifically not to trigger onclickoutside which would close the UI instead of selecting the value
          // More: https://www.npmjs.com/package/react-cool-onclickoutside#user-content-ignore-elements-by-css-class-name
          className="ignore-onclickoutside"
        >
          {children}
        </Paper>
      )}
      renderInput={(params) => {
        return (
          <TextField
            {...params}
            placeholder="e.g. UTC-6 or European Union"
            className=""
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {isLoading ? (
                    <BeatLoader size={8} margin={2} color="#aaa" />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        );
      }}
    />
  );
};
